export const articlesTypes = {
  home: "home",
  all: "all",
};
